<div class="flex flex-col rounded-md border-2 border-slate-300 bg-white p-4 pr-16">
  <button class="mb-2" (click)="assessed.emit('CORRECT')">
    <div
      class="grid size-16 cursor-pointer place-items-center rounded-full border-4 border-emerald-500 bg-emerald-100 text-emerald-500 hover:bg-emerald-200"
    >
      <i-checkmark class="size-8" />
    </div>
  </button>
  <button class="mt-2" (click)="assessed.emit('INCORRECT')">
    <div
      class="grid size-16 cursor-pointer place-items-center rounded-full border-4 border-red-500 bg-red-100 text-red-500 hover:bg-red-200"
    >
      <i-cross class="size-6" />
    </div>
  </button>
</div>
